// AI-generated with Claude Code.

/** Shared by the sign-up, sign-in and password forms and the worker's validation. */
export const MIN_PASSWORD_LENGTH = 10

export const USERNAME_MIN_LENGTH = 3
export const USERNAME_MAX_LENGTH = 30

const USERNAME_PATTERN = /^[a-z0-9._-]+$/

/** Usernames are matched case-insensitively, so they are stored lowercased. */
export function normaliseUsername(input: string): string {
  return input.trim().toLowerCase()
}

/** Explains what's wrong with a (normalised) username, or returns null when it's fine. */
export function usernameProblem(username: string): string | null {
  if (username.length < USERNAME_MIN_LENGTH) return `Use at least ${USERNAME_MIN_LENGTH} characters.`
  if (username.length > USERNAME_MAX_LENGTH) return `Use at most ${USERNAME_MAX_LENGTH} characters.`
  if (!USERNAME_PATTERN.test(username)) return 'Use only letters, numbers, dots, dashes and underscores.'
  return null
}

/** Sign-in takes one field: anything with an @ is a parent's email, anything else a kid's username. */
export function isEmailIdentifier(identifier: string): boolean {
  return identifier.includes('@')
}
